<template>
  <div>
    <div class="black-overlay"></div>
    <div :class="['modal', 'modal--welcomeback no_space']" id="open_box">
      <div class="modal__content">
        <button @click="goToGetStarted" class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header">
          <h1> {{ getTranslations.home_modals_post_game_free_play_prize_yeah }}

          </h1>
          <h1> {{ getTranslations.home_modals_post_game_free_play_prize_won }} [{{ freePlayPrize.name }}]</h1>
        </div>


        <div class="modal__body achievement">

          <div class="spinning_wheel prize">
            <div class="bounce_box bounce_animation">
              <img class="icon" src="/static/images/bonus_points.svg" alt="">
            </div>
            <a @click.prevent="savePoints()" class="btn2 btn2--std btn2--small" style="cursor:pointer">{{ getTranslations.home_modals_post_game_free_play_prize_claim }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapGetters, mapState, mapMutations } from 'vuex';

export default {
  name: 'PostGameFreePlayPrizeWon',
  data() {
    return {
      correctAnswersPoints: 0,
      gameVictoryPoints: 0,
      totalEarnedPoints: 0,
      homeScore: 0,
      awayScore: 0,
    };
  },
  created() {
    this.$nextTick(() => {
      // eslint-disable-next-line
      $('#spinning_wheel').hide();
    });
    console.log('in PostGame created hook:');
    this.correctAnswersPoints = this.homePlayerRoundScore * 100;
    if (this.gameWinnerMSISDN === 'trial user') {
      this.homeScore = 1;
      this.gameVictoryPoints = 200;
    } else {
      this.awayScore = 1;
    }
    this.totalEarnedPoints = this.correctAnswersPoints + this.gameVictoryPoints;
  },
  methods: {
    ...mapMutations('game', [
      'storeRegistrationPoints',
    ]),
    goToRegistration() {
      if (this.freeTrialRedirectionUrl) { // if property "free.trial.redirection.url" exists redirect to it otherwise to register1
        window.location.href = `${this.freeTrialRedirectionUrl}?refUrl=${this.getRefUrl || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=trial&freeGamePrize=1`;
      } else {
        this.$router.push('/');
      }
    },
    goToGetStarted() {
      this.$router.push('/');
    },
    savePoints() {
      this.$nextTick(() => {
        // eslint-disable-next-line
        $('#click').hide();
        // eslint-disable-next-line
        $('#gif-click').show();
        // eslint-disable-next-line
        $('#pic-click').hide();
      });
      this.storeRegistrationPoints({
        freeGamePrize: 1000,
      });
      this.goToRegistration();
    },
  },
  computed: {
    ...mapState('common', [
      'freeTrialRedirectionUrl',
    ]),
    ...mapState('game', [
      'playersDetails',
      'homePlayerRoundScore',
      'awayPlayerRoundScore',
      'gameWinnerMSISDN',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'isEqualAmountOfCorrectAnswers',
    ]),
    ...mapState('profile', [
      'freePlayPrize',
    ]),
    ...mapGetters('common', [
      'getRefUrl',
      'getClickId',
      'getCampaignId',
      'getPublisherId',
    ]),
    determineWinnerCSSClass() {
      return (this.gameWinnerMSISDN === 'trial user') ? 'player1' : 'player2';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeTrial/modals/PostGameFreePlayPrizeWon.vue